import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Sider
import Home from './pages/Home';
import Diamantboring from './pages/Diamantboring';
import OmOs from './pages/OmOs';
import Galleri from './pages/Galleri';
import Kontakt from './pages/Kontakt';
import NotFound from './pages/404';
import Forbidden from './pages/403';

function App() {
  return (
    <>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen bg-neutral-950 text-neutral-100 selection:bg-brand-orange selection:text-white">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/diamantboring" element={<Diamantboring />} />
            <Route path="/om-os" element={<OmOs />} />
            <Route path="/galleri" element={<Galleri />} />
            <Route path="/kontakt" element={<Kontakt />} />
            <Route path="/403" element={<Forbidden />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </>
  );
}

export default App;
